import { Params, ParamMap } from '@angular/router';

const CUSTOMER_KEY = 'cust';

export const toCustomerParams = (args: { customerId?: number }): Params =>
	args.customerId
		? {
				[CUSTOMER_KEY]: args.customerId ? args.customerId : undefined,
		  }
		: undefined;

export const toCustomerListArgs = (
	paramMap: ParamMap
): { customerId?: number } =>
	paramMap.has(CUSTOMER_KEY)
		? {
				customerId: +paramMap.get(CUSTOMER_KEY),
		  }
		: undefined;
